/**
 * GlassSection Component
 *
 * Standardized translucent-glass section wrapper used to stack content
 * blocks on a page. Optional title (IM Fell English) + actions slot
 * mirror the pattern from HomePage's section headers.
 *
 * For finer-grained card-level surfaces (within a section), use the
 * existing GlassCard component.
 *
 * Usage:
 *   <GlassSection title="Featured Island Businesses"
 *                 actions={<Link to="/business-listings">View All</Link>}>
 *     <div className="grid">{...}</div>
 *   </GlassSection>
 */

import React from 'react';
import './GlassSection.css';
import { GlassCard, GLASS_VARIANTS, GLASS_PADDING } from '../GlassCard';

export function GlassSection({
  title,
  subtitle,
  actions,
  variant = GLASS_VARIANTS.STRONG,
  padding = GLASS_PADDING.LG,
  as = 'section',
  headingLevel = 2,
  className = '',
  headerClassName = '',
  bodyClassName = '',
  children,
  ...rest
}) {
  const HeadingTag = `h${headingLevel}`;
  const hasHeader = title || subtitle || actions;

  return (
    <GlassCard
      as={as}
      variant={variant}
      padding={padding}
      className={['glass-section', className].filter(Boolean).join(' ')}
      {...rest}
    >
      {hasHeader && (
        <header className={['glass-section__header', headerClassName].filter(Boolean).join(' ')}>
          <div className="glass-section__heading-text">
            {title && (
              <HeadingTag className="glass-section__title">{title}</HeadingTag>
            )}
            {subtitle && <p className="glass-section__subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="glass-section__actions">{actions}</div>}
        </header>
      )}
      <div className={['glass-section__body', bodyClassName].filter(Boolean).join(' ')}>
        {children}
      </div>
    </GlassCard>
  );
}

export default GlassSection;
